import {COLUMN_CODE, TableManger as TableManager, TableManger, TABLES} from "../managers/TableManger";
import Table from "./table";
import {showLoader, removeLoader} from "deskera-ui-library";
import { DealManager } from "../managers/DealManager";

class FormService {
    static pipeLineData;

    static getContactData(isDefault) {
        let ignoreColumns = [COLUMN_CODE.CANDIDATE.TYPE, COLUMN_CODE.CANDIDATE.JOBOPENING, COLUMN_CODE.CAMPAIGN.STATUS, COLUMN_CODE.CANDIDATE.LABEL, COLUMN_CODE.CANDIDATE.PROFILE_PIC]
        let defaultColumns = [COLUMN_CODE.CAMPAIGN.NAME, COLUMN_CODE.CANDIDATE.PHONE, COLUMN_CODE.CANDIDATE.EMAIL, COLUMN_CODE.CANDIDATE.DOCUMENT]
        let allContactColumns = TableManger.getTableColumns(TABLES.CANDIDATE)
        let filteredColumns = (allContactColumns || []).filter(item => item.uiVisible === true)
        if (isDefault) {
            return (filteredColumns || []).filter(item => defaultColumns.includes(item.columnCode))
        } else {
            return (filteredColumns || []).filter(item => !ignoreColumns.includes(item.columnCode))
        }
    }

    static getContactDataForLandingPages() {
        let defaultColumns = [COLUMN_CODE.CANDIDATE.NAME, COLUMN_CODE.CANDIDATE.EMAIL]
        let allContactColumns = TableManger.getTableColumns(TABLES.CANDIDATE)
        let filteredColumns = (allContactColumns || []).filter(item => item.uiVisible === true)
        return (filteredColumns || []).filter(item => defaultColumns.includes(item.columnCode))
    }

    static save(data: any, onSuccess: any, onError: any) {
        showLoader("Saving... Please wait");
        const record = {
            cells: data,
        };
        Table.addRecord(record, TableManager.getTableId(TABLES.JOB_FORMS)).then(
            (response) => {
                removeLoader()
                onSuccess(response);
            },
            (error) => {
                removeLoader()
                onError(error);
            }
        );
    }

    static update(data: any, recordId: any, onSuccess: any, onError: any) {
        showLoader("Updating... Please wait");
        Table.updateRecord(
            data,
            recordId,
            TableManager.getTableId(TABLES.JOB_FORMS)
        ).then(
            (response) => {
                removeLoader();
                onSuccess(response);
            },
            (error) => {
                removeLoader();
                onError(error);
            }
        );
    }

    static getData(recordId: string, onSuccess: any, onError: any) {
        showLoader("Fetching... Please wait");
        Table.getRecordById(
            recordId,
            TableManager.getTableId(TABLES.JOB_FORMS)
        ).then(
            (response) => {
                removeLoader();
                onSuccess(response);
            },
            (error) => {
                removeLoader();
                onError(error);
            }
        );
    }
    static getPipelineData() {
        let pipelienTableId = TableManager.getTableId(TABLES.JOB_PIPELINE);
        let pipeline = Table.getRecords(pipelienTableId).then((res) => {
            return this.pipeLineData = DealManager.jobPipelineData(res);
        });
    }
    static getSelectedPipelineIndex(selectedSegmentIds,selectedPipeline, segmentData) {
        const selectedIndex = [];
        if (Array.isArray(selectedSegmentIds)) {
            selectedSegmentIds.forEach(element => {
                let isPresent = segmentData.some(x => x.id === element);
                if (isPresent) {
                    let index = segmentData.findIndex(x => x.id === element);
                    selectedIndex.push(index);
                }
            });
        }
        if (Array.isArray(selectedPipeline)) {
            selectedPipeline.forEach(element => {
                let isPresent = segmentData.some(x => x.id === element);
                if (isPresent) {
                    let index = segmentData.findIndex(x => x.id === element);
                    selectedIndex.push(index);
                }
            });
        }
        return selectedIndex.length == 0 ? [0] : selectedIndex;
    }
}

export default FormService
